import { API_CONFIDENTIAL_INFORMATION } from '@common/api/graphql/getProjectsGql';
import type {
  LocalAPIConfidentialInformation,
  LocalConfidentialInformation
} from '@console/reducers/projects';

export const isAPIConfidentialInformation = (
  confidentialInformation: LocalConfidentialInformation
): confidentialInformation is LocalAPIConfidentialInformation =>
  confidentialInformation.__typename === API_CONFIDENTIAL_INFORMATION;
